import { de_DE_formal } from "@App/locales/de_DE-formal";
import { de_DE_globalTranslations } from "@App/locales/de_DE-globalTranslations";

export const mobileGarantie = {
  ...de_DE_formal,
  ...{
    translation: {
      ...de_DE_globalTranslations.translation,
      "Partnerwerkstaetten in Ihrer Naehe": "mobile GARANTIE Werkstätten in Ihrer Nähe",
      hero: {
        title: "<strong>{{organization}}<br>Werkstattbuchung</strong>",
        subtitle: null,
      },
      layout: {
        backText: "Zurück zu mobile-garantie.de",
        navbar: {
          partnerLogo: {
            alt: "mobile GARANTIE",
          },
        },
      },
      garageList: {
        ...de_DE_formal.translation.garageList,
        emptyState: {
          ...de_DE_formal.translation.garageList.emptyState,
          headline: "Wir haben leider keine Werkstatt in Ihrer Nähe gefunden.",
          description:
            "Wir sind bemüht, das Netzwerk an Werkstätten und Prüfstellen, die direkt über die Plattform gebucht werden können, ständig zu erweitern. Aktuell gibt es in Ihrer Nähe leider noch keine buchbare Werkstatt für Ihren Service.",
        },
      },
      hotline: {
        "hotline-headline": "Bei Fragen wenden Sie sich bitte an:",
        "hotline-phone-link": "tel:051309757030",
        "hotline-phone": "051309757030",
        "hotline-availability": "",
        "hotline-via-email": "Oder per E-Mail an: ",
        "hotline-via-email-email": "schaden.melden@mobile-garantie.de",
      },
      linkToHome: "https://werkstatt.repareo.de/partner/mobile-garantie",
      contactForm: {
        ...de_DE_formal.translation.contactForm,
        contractNumber: { label: "Garantienummer", placeholder: "XXX-XXXXXX" },
      },
      contractNumberStep: {
        label: "Garantienummer",
        placeholder: "XXX-XXXXXX",
        help: {
          trigger: "Wo finde ich meine Garantienummer?",
          hint: "Sie steht oben auf Ihrer Garantieurkunde, direkt hinter „GKV - Zertifikat Nr.“.",
        },
        submit: "Vertrag finden",
        submitLoading: "Wird gesucht …",
        skip: "Überspringen",
        errors: {
          format: "Bitte geben Sie die Garantienummer im Format XXX-XXXXXX ein.",
          notFound:
            "Fahrzeug nicht gefunden. Bitte überprüfen Sie die Garantienummer oder überspringen Sie diesen Schritt.",
        },
      },
    },
  },
};
